const PawPrint = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg className={className} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="8" cy="6.5" rx="2.2" ry="2.8" />
    <ellipse cx="16" cy="6.5" rx="2.2" ry="2.8" />
    <ellipse cx="4.5" cy="11.5" rx="2" ry="2.6" />
    <ellipse cx="19.5" cy="11.5" rx="2" ry="2.6" />
    <path d="M12 22c-4 0-7-2.5-7-5.5 0-2 1.5-3.5 3-4.5 1.2-.8 2.5-1 4-1s2.8.2 4 1c1.5 1 3 2.5 3 4.5 0 3-3 5.5-7 5.5z" />
  </svg>
);

export default PawPrint;
